import type {
	SubscriptionBehaviorResponse,
	SubscriptionProductConfigResponse,
} from "libs/apiClient";

export type SubscriptionBehavior = SubscriptionBehaviorResponse;

export function resolveProductBehavior(
	config: SubscriptionProductConfigResponse | undefined,
	productValue: string | null | undefined,
): SubscriptionBehavior | undefined {
	if (!config) {
		return undefined;
	}

	if (!productValue) {
		return config.defaultProductConfig?.behavior;
	}

	const match = config.products.find((product) => product.value === productValue);
	return match?.behavior ?? config.defaultProductConfig?.behavior;
}
